import React from 'react';
export function PressQuote() {
  return <section className="bg-cream py-[100px] px-8" data-id="element-162">
      <div className="max-w-[900px] mx-auto text-center section-reveal" data-id="element-163">
        <span className="block font-optima font-light text-[14px] uppercase text-gold tracking-[0.15em] mb-8" data-id="element-164">
          AWARDS & MEDIA
        </span>

        <blockquote className="font-optima italic text-[20px] md:text-[24px] text-charcoal leading-[1.6]" data-id="element-165">
          "The first Shiraz we tasted was on the day we arrived: Glenlofty's
          2023 from the rugged Pyrenees subregion with its cold winters and cool
          nights. It was the first time I'd encountered Shiraz like this. Like
          nothing from anywhere else."
        </blockquote>

        <div className="font-optima font-light text-[16px] text-gold mt-6" data-id="element-166">
          — Tamlyn Currin, JancisRobinson.com
        </div>
      </div>
    </section>;
}